import React, { lazy, Suspense } from "react";
import "../styles/backgroundLoad.css";
import backgroundImg from "../images/BG-hands.webp";
import CharityByCategoryList from "../components/CharityByCategoryList";
import SearchBar from "../components/SearchBar";
import { CustomLink } from "../components/CustomLink";

const LazyFooter = lazy(() => import("../components/Footer"));
const LazyHeader = lazy(() => import("../components/Header"));
const isDataLoad = true;

const NOnProfit = ({ pageContext }) => {
  const categoryTitle = pageContext?.title;
  const mainCategory = pageContext?.mainCategory;

  const sortedCards = pageContext?.charities;
  const categoryLength = sortedCards.length;
  
  let title = "";
  if (mainCategory) {
    title = `Showing ${  categoryLength  } `;
    let tmpCat = categoryTitle.toLowerCase();
    if (tmpCat.includes("medium")) 
      tmpCat = categoryTitle.replace(" charities", "-sized charities");
    title += categoryLength !== 1 ? tmpCat : tmpCat.replace("charities","Charity") 
    title += " ";
  }
  else 
    title = `The ${  categoryTitle   } `;    
  
 
  if (!categoryTitle.includes("charities")) {
    title += categoryLength === 1 ? "Nonprofit" : "Nonprofits";
  }


  return (
    <Suspense fallback={<div />}>
      {isDataLoad &&
      <div>
        <LazyHeader/>
        <div>
          <div
            className="w-full px-7 pb-[30px] pt-10 lg:px-28 lg:pt-[60px] xl:px-28 2xl:px-32"
            style={{
              backgroundImage: `url(${backgroundImg})`,
              backgroundSize: "cover"
            }}>
            <h1 className="text-center text-2xl font-bold capitalize lg:text-5xl">
              {title}
            </h1>
            <div className="mt-7 ">
              <SearchBar/>
            </div>
          </div>
          <div className="w-full overflow-x-auto p-7 lg:px-28 xl:px-28 2xl:px-32">
            <CharityByCategoryList charityList={sortedCards} />
          </div>
          <div
            className="my-6 px-7 md:my-2 md:flex-row md:justify-between lg:px-28 xl:px-28 2xl:px-32"
            style={{
              display: "flex",
              flexDirection: "column-reverse"
            }}
          >
            <CustomLink href="/" className="flex justify-center md:justify-start">
              <button className="flex justify-center rounded-lg  bg-primary p-4 text-lg  font-semibold  shadow-[0px_4px_10px_0px_#00000026]" type="button">
                EXPLORE OTHER CHARITIES
              </button>
            </CustomLink>
          </div>
        </div>
        <LazyFooter/>
      </div>}
    </Suspense>
  );
};
export default NOnProfit;

export const Head = ({pageContext}) =>
  <>
    <title>{pageContext?.pgTitle ?? "Charity List"}</title>
    <meta name="description" content={pageContext?.mainCategory ? `Alphabetical listing of ${pageContext?.title.toLowerCase()} ${pageContext?.mainCategory ? "nonprofits " : " " }from ${pageContext?.subCat.replace(" - ", "-")} - view their mission, revenue, if they are legit, and CEO's salary`.replace("medium", "medium-sized") 
    :
     `Alphabetical list of the ${pageContext?.title.toLowerCase()} by revenue - see their mission, revenue, if they are legit, and CEO's salary`}/>
  </>
